import React from 'react'
import { connect } from 'kea'
import { useMediaQuery } from 'react-responsive'
import Tooltip from 'rc-tooltip'

import I18n from 'lib/i18n'

import PriceWithSeparateCents from '~/scenes/shared/price-with-separate-cents'
import PriceOverlay from './overlay'

import { MAX_MEDIUM_WIDTH, MAX_SMALL_WIDTH, MIN_MEDIUM_WIDTH } from './constants.js'

import courseLogic from '~/scenes/course/show/logic'

export default connect({
  props: [courseLogic, ['course']]
})(({ course: { priceSeparateCents } }) => {
  const isMobileView = useMediaQuery({ maxWidth: MAX_SMALL_WIDTH })
  const isTabletView = useMediaQuery({ minWidth: MIN_MEDIUM_WIDTH, maxWidth: MAX_MEDIUM_WIDTH })
  return (
    <Tooltip
      trigger={['hover']}
      placement={isMobileView || isTabletView ? 'topRight' : 'topLeft'}
      overlay={<PriceOverlay />}
    >
      <div className='price-container'>
        <span className='trigger show-rates-from'>{I18n.t('courses.show.from')}</span>
        <PriceWithSeparateCents priceSeparateCents={priceSeparateCents} perHourClass='per-hour-label' />
      </div>
    </Tooltip>
  )
})
